import { Auth, API } from "aws-amplify";

const photoBucket =
  "https://riparian-production-user-data.s3.us-west-2.amazonaws.com";

async function getATS() {
  return API.get("mapApi", "/ats_lsd.json", {});
}

const sanitizeJSON = (s) => {
  return s.replace(/\n/g, "\\n")
}

const buildPOGs = (pogs) => {
  // Sort pogs by transaction
  pogs = pogs
    .sort((a, b) => {
      a = a.usertransaction.S;
      a = parseInt(a.slice(3));
      b = b.usertransaction.S;
      b = parseInt(b.slice(3));

      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    })
    .reverse();

  let builtPogs = [];
  pogs.forEach((pog) => {
    try {
      let pogData = JSON.parse(sanitizeJSON(pog.payload.S));
      pogData.usertransaction = pog.usertransaction.S;
      pogData.id = parseInt(pogData.usertransaction.slice(3));
      builtPogs.push(pogData);
    } catch (err) {
      console.warn(`${err}: ${pog.payload.S}`); // eslint-disable-line no-console
    }
  });
  return builtPogs;
};

async function getPOGs() {
  const pogs = await API.get("api", "/pogs", {});
  return buildPOGs(pogs.Items);
}

async function getPrivatePOGs() {
  let authData = await Auth.currentSession();
  let header = {
    headers: { Authorization: authData.idToken.jwtToken },
  };
  const pogs = await API.get("api", "/adminpogs", header);
  return buildPOGs(pogs.Items);
}

const makePOGDBSafe = (pog) => {
  pog.name = pog.name.replace(/"/g, "'").replace(/\n/g, "\\n");
  pog.description = pog.description.replace(/"/g, "'").replace(/\n/g, "\\n");
  pog.comments.forEach((comment) => {
    comment.text = comment.text.replace(/"/g, "'").replace(/\n/g, "\\n");
  });
};

async function createPOG(pog) {
  const user = await Auth.currentAuthenticatedUser();
  const authData = await Auth.currentSession();
  let date = new Date();
  let pogID = pog.usertransaction;

  if (!pogID) {
    // POG is being created, not edited
    pog.created = date
      .toString()
      .split(" ")
      .slice(0, 5)
      .join(" ");
    let pogs = await getPOGs();
    let privatePOGs = await getPrivatePOGs();
    pogs = [...pogs, ...privatePOGs];

    const filteredPogs = pogs.filter((p) => {
      return p.createdByUser === user.username;
    });

    const pogIDs = filteredPogs.map((p) => {
      return parseInt(p.usertransaction.slice(3));
    });

    let maxID;
    if (pogIDs.length === 0) {
      maxID = -1;
    } else {
      maxID = Math.max(...pogIDs);
    }

    pogID = `pog${maxID + 1}`;
    pog.createdByUser = user.username;
  }
  makePOGDBSafe(pog);
  let payload = {
    body: {
      public: pog.public,
      time: date
        .toString()
        .split(" ")
        .slice(0, 5)
        .join(" "),
      payload: [...JSON.stringify(pog)]
        .map((char) => {
          return char === '"' ? '\\"' : char;
        })
        .join(""),
    },
    headers: { Authorization: authData.idToken.jwtToken },
  };
  if (!pogID) {
    return API.put("api", `/${user.username}/${pogID}`, payload);
  } else {
    // Use the creator as the PK
    return API.put("api", `/${pog.createdByUser}/${pogID}`, payload);
  }
}

async function deletePOG(pogID) {
  const user = await Auth.currentAuthenticatedUser();
  let authData = await Auth.currentSession();
  return API.del("api", `/${user.username}/${pogID}`, {
    body: {},
    headers: { Authorization: authData.idToken.jwtToken },
  });
}

async function getPOGPhoto(pog, photoID, fromSource) {
  let photo;

  if (fromSource) {
    const userObject = await Auth.currentAuthenticatedUser();
    photo = fromSource;
    photo.folder = userObject.username;
  } else {
    photo = pog.photos.filter((p, idx) => {
      if (p.i === undefined) {
        // Legacy - no .i attribute
        return idx === photoID;
      } else return p.i === photoID;
    })[0];
  }

  if (!photo) throw new Error("Unable to match Photo ID");

  const encodedPhotoName = encodeURIComponent(photo.name);

  return `${photoBucket}/${photo.folder}/${encodedPhotoName}`;
}

const getPOGCoverPhoto = async (pog) => {
  if (!pog.photos[0].x) return getPOGPhoto(pog, 0);
  else {
    const x = Math.min(...pog.photos.map((p) => p.x));
    const y = Math.min(...pog.photos.map((p) => p.y));

    const photoID = pog.photos.filter((p) => {
      return p.x === x && p.y === y;
    })[0].i;

    return getPOGPhoto(pog, photoID);
  }
};

export {
  getATS,
  getPOGs,
  getPrivatePOGs,
  createPOG,
  deletePOG,
  getPOGPhoto,
  getPOGCoverPhoto,
};
